import script from "./customIptv.vue?vue&type=script&lang=ts&setup=true"
export * from "./customIptv.vue?vue&type=script&lang=ts&setup=true"

import "./customIptv.vue?vue&type=style&index=0&id=e62f34e0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e62f34e0"]])

export default __exports__